import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button } from "@mui/material";
import "./prisma-lab-banner.container.css";
import { Container } from "../../components/container/container";

type PrismaLabBannerProps = {
  url: string;
};

export function PrismaLabBanner({ url }: PrismaLabBannerProps) {
  return (
    <div className="xvia-prisma-lab-banner__container">
      <Container>
        <section
          className="xvia-prisma-lab-banner"
          style={{
            backgroundImage: `url("${process.env.PUBLIC_URL}/images/svgs/bg-whatsapp-banner.svg")`,
            backgroundSize: "cover",
            backgroundPosition: "right end",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="xvia-prisma-lab-banner__content">
            <div className="xvia-prisma-lab-banner__content-text-container">
              <div className="xvia-prisma-lab-banner__title">
                Ajude-nos a desenhar o futuro do Piauí!
              </div>
              <p className="xvia-prisma-lab-banner__content-text">
                O Prisma Lab é um espaço para promover melhoria contínua,
                evolução dos serviços e validação dos nossos sistemas.
              </p>
              <ul className="xvia-prisma-lab-banner__list">
                <li>Contribua com melhorias</li>
                <li>Influencie decisões</li>
                <li>Ajude a validar serviços</li>
              </ul>
            </div>
            <div
              className="xvia-prisma-lab-banner__content-image-container"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/svgs/group1.svg)`,
              }}
            />
            <Button
              endIcon={<OpenInNewIcon style={{ fontSize: 20 }} />}
              variant="contained"
              size="small"
              className="xvia-prisma-lab-banner__content-button"
              onClick={() => {
                window.open(url, "_blank");
              }}
            >
              Conhecer Prisma Lab
            </Button>
          </div>
        </section>
      </Container>
    </div>
  );
}
